import { render } from "./index.vue?vue&type=template&id=17e26f4a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=17e26f4a&scoped=true&lang=css"

import exportComponent from "D:\\code\\dapp-wallet\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e26f4a"]])

export default __exports__